<template>
  <div>
    <v-row no-gutters align="center">
      <v-spacer />
      <!-- Button show dialog create maintain -->
      <v-btn color="success" @click="dialogCreateNotification = true"
        >新規作成</v-btn
      >
    </v-row>
    <!-- List maintain -->
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table
        :headers="headers"
        fixed-header
        :items="listNotification"
        :loading="loadingGetListNotification"
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        class="elevation-1"
      >
        <!-- Status -->
        <template v-slot:item.type="{ item: { type } }">
          <!-- If status notification [PUBLISH/公開] -->
          <v-chip
            small
            color="#70C140"
            class="status-maintain"
            text-color="white"
            v-if="type == 'PUBLISH'"
          >
            {{ type | statusNotification }}
          </v-chip>
          <!-- If status UNPUBLISH [UNPUBLISH/非公開] -->
          <v-chip
            small
            color="#E0E0E0"
            class="status-maintain"
            v-if="type == 'UNPUBLISH'"
          >
            {{ type | statusNotification }}
          </v-chip>
          <!-- If status REMOVE [REMOVE/取り下げ] -->
          <v-chip
            color="#EE5F59"
            small
            text-color="white"
            v-if="type == 'REMOVE'"
            class="status-maintain"
          >
            {{ type | statusNotification }}
          </v-chip>
        </template>
        <!-- publish time -->
        <template v-slot:item.publish_time="{ item: { publish_time } }">
          {{ publish_time | dateTime }}
        </template>
        <!-- created time -->
        <template v-slot:item.unpublish_time="{ item: { created_at } }">
          {{ created_at | dateTime }}
        </template>
        <!-- remove time -->
        <template v-slot:item.remove_time="{ item: { remove_time } }">
          {{ remove_time | dateTime }}
        </template>
        <template v-slot:item.actions="{ item, item: { Id, type } }">
          <div class="d-flex justify-end">
            <!--  Edit -->
            <v-btn
              small
              color="#D81B60"
              outlined
              class="mr-3 text-button"
              @click="showDialogUpdate(item)"
              >確認</v-btn
            >
            <!--  Detele -->
            <v-btn
              :disabled="type != 'UNPUBLISH'"
              small
              color="error"
              @click="showDialogComfirmDelete(Id)"
              >削除</v-btn
            >
          </div>
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <strong class="mt-4 mr-2">表示件数</strong>
      <v-select
        class="max-width-1 mt-2"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <v-spacer />
      <BasePagination
        v-if="listNotification.length > 0"
        class="mt-5"
        :pageCount="listNotification.length"
        :pageSize="pagination.maxResultCount"
        @changePage="(value) => (pagination.page = value)"
      />
    </v-row>
    <!-- Dialog create notification -->
    <DialogCreateNotification
      v-model="dialogCreateNotification"
      :data="listNotification"
      :key="`DialogCreateNotification-${keyDialogCreateNotification}`"
      @resetList="fetchListNotification"
    />
    <!-- Dialog update maintain -->
    <DialogUpdateNotification
      v-model="dialogUpdateuNotification"
      :itemUpdate="itemUpdate"
      :data="listNotification"
      @resetList="fetchListNotification"
    />
    <!-- Dialog confirm delete -->
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="350">
      <v-card>
        <v-card-title class="headline justify-center">
          <span>確認</span>
        </v-card-title>
        <v-card-text class="pb-0"> 削除します。よろしいですか </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="font-weight-bold"
            :loading="loadingDelete"
            @click="handleDeleteNotification"
            small
            >OK</v-btn
          >
          <v-btn @click="dialogConfirmDelete = false" small>キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import mixin from "@/mixin";
import DialogCreateNotification from "./DialogCreateNotification";
import DialogUpdateNotification from "./DialogUpdateNotification";
import { getListNotification, deleteNotification } from "@/api/MasterData.api";
import BasePagination from "@/components/Pagination/BasePagination";
import vm from "@/main";
export default {
  mixins: [mixin.App],
  components: {
    DialogCreateNotification,
    DialogUpdateNotification,
    BasePagination,
  },
  data() {
    return {
      dialogCreateNotification: false,
      dialogUpdateuNotification: false,
      dialogConfirmDelete: false,
      actionId: "",
      //   Header list maintain
      headers: [
        // Status
        { text: "公開状態", value: "type" },
        // publish time
        { text: "公開日時", value: "publish_time" },
        // created time
        { text: "作成日時", value: "unpublish_time" },
        // remove time
        { text: "取り下げ日時", value: "remove_time" },
        // Title
        { text: "タイトル", value: "title" },
        // Detail
        { text: "内容", value: "content" },
        // Action
        {
          text: "操作",
          value: "actions",
          width: "100px",
          align: "center",
        },
      ],
      //   List data
      listNotification: [],
      //   Loading get list
      loadingGetListNotification: false,
      //   Loading delete
      loadingDelete: false,
      //   key dialog create
      keyDialogCreateNotification: 0,
      //   item Update
      itemUpdate: {},
    };
  },
  async mounted() {
    await this.fetchListNotification();
  },
  filters: {
    statusNotification: function (val) {
      let status =
        // PUBLISH
        val == "PUBLISH"
          ? "公開"
          : // UNPUBLISH
          val == "UNPUBLISH"
          ? "非公開"
          : // REMOVE
            "取り下げ";
      return status;
    },
    dateTime: function (val) {
      const { $moment } = vm;
      if (!val) return "";
      return $moment.unix(val).format("YYYY年MM月DD HH:mm");
    },
  },
  watch: {
    dialogCreateNotification: function () {
      this.keyDialogCreateNotification++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
    },
  },
  methods: {
    fetchListNotification: async function () {
      this.loadingGetListNotification = true;
      const { result } = await getListNotification().catch(this.$toast.error);
      this.loadingGetListNotification = false;
      if (!result) return;
      this.listNotification = result;
    },
    showDialogComfirmDelete: function (id) {
      this.dialogConfirmDelete = true;
      this.actionId = id;
    },
    showDialogUpdate: function (item) {
      console.log("item: ", item);
      this.itemUpdate = item;
      this.dialogUpdateuNotification = true;
    },
    handleDeleteNotification: async function () {
      let params = {
        id: this.actionId,
      };
      this.loadingDelete = true;
      await deleteNotification(params)
        .then(() => {
          this.dialogConfirmDelete = false;
          this.fetchListNotification();
        })
        .catch(this.$toast.error);
      this.loadingDelete = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.status-maintain {
  min-width: 100px;
  font-weight: bold;
}
::v-deep .status-maintain span {
  margin: 0 auto;
}
</style>